var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "45px",
    width: "45px",
    id: "sunset",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1010 846.4933",
    enableBackground: "new 0 0 1010 846.4933",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#37474F",
    d: "M995.5197,633.9287H14.4807C6.4851,633.9287,0,627.4579,0,619.4484 c0-7.9817,6.4851-14.4803,14.4807-14.4803h981.039c8.0095,0,14.4803,6.4986,14.4803,14.4803 C1010,627.4579,1003.5292,633.9287,995.5197,633.9287L995.5197,633.9287z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#37474F",
    d: "M815.6505,748.3925H194.3352c-7.996,0-14.4811-6.4847-14.4811-14.4812 c0-7.9957,6.4851-14.4803,14.4811-14.4803h621.3154c8.0103,0,14.4951,6.4847,14.4951,14.4803 C830.1456,741.9077,823.6608,748.3925,815.6505,748.3925L815.6505,748.3925z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#37474F",
    d: "M619.4627,846.4933H406.8989c-7.9956,0-14.4807-6.4855-14.4807-14.4803 c0-7.9965,6.4851-14.4813,14.4807-14.4813h212.5638c7.9964,0,14.4803,6.4847,14.4803,14.4813 C633.943,840.0078,627.4591,846.4933,619.4627,846.4933L619.4627,846.4933z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFCA72",
    d: "M181.5359,547.0164c0-179.4907,145.4768-324.9743,324.9601-324.9743 c179.4697,0,324.9607,145.4836,324.9607,324.9743"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#37474F",
    d: "M831.4567,561.4976c-8.0103,0-14.4811-6.4995-14.4811-14.4812 c0-171.2098-139.2764-310.494-310.4796-310.494c-171.2024,0-310.4792,139.2842-310.4792,310.494 c0,7.9817-6.4851,14.4812-14.4808,14.4812c-7.9956,0-14.4803-6.4995-14.4803-14.4812 c0-187.1797,152.2749-339.4551,339.4404-339.4551c187.1658,0,339.442,152.2753,339.442,339.4551 C845.938,554.998,839.4524,561.4976,831.4567,561.4976L831.4567,561.4976z"
  })), /*#__PURE__*/React.createElement("line", {
    fill: "#FFCA72",
    x1: 14.4807,
    y1: 537.6948,
    x2: 112.5816,
    y2: 537.6948
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#37474F",
    d: "M112.5816,552.176H14.4807C6.4851,552.176,0,545.7051,0,537.6948c0-7.981,6.4851-14.4804,14.4807-14.4804 h98.1009c8.0103,0,14.4951,6.4995,14.4951,14.4804C127.0767,545.7051,120.5919,552.176,112.5816,552.176L112.5816,552.176z"
  })), /*#__PURE__*/React.createElement("line", {
    fill: "#FFCA72",
    x1: 153.1449,
    y1: 133.9322,
    x2: 246.2572,
    y2: 227.0588
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#37474F",
    d: "M246.2572,241.5396c-3.7056,0-7.3969-1.411-10.2334-4.2401l-93.127-93.127 c-5.6581-5.6581-5.6581-14.8228,0-20.4809c5.6585-5.6585,14.8233-5.6585,20.4814,0l93.127,93.1266 c5.6581,5.6585,5.6581,14.8229,0,20.4814C253.6685,240.1285,249.9633,241.5396,246.2572,241.5396L246.2572,241.5396z"
  })), /*#__PURE__*/React.createElement("line", {
    fill: "#FFCA72",
    x1: 995.5197,
    y1: 537.6948,
    x2: 913.7661,
    y2: 537.6948
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#37474F",
    d: "M995.5197,552.176h-81.7536c-8.0104,0-14.4804-6.4708-14.4804-14.4811 c0-7.981,6.47-14.4804,14.4804-14.4804h81.7536c8.0095,0,14.4803,6.4995,14.4803,14.4804 C1010,545.7051,1003.5292,552.176,995.5197,552.176L995.5197,552.176z"
  })), /*#__PURE__*/React.createElement("line", {
    fill: "#FFCA72",
    x1: 859.8339,
    y1: 133.9322,
    x2: 766.7068,
    y2: 227.0588
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#37474F",
    d: "M766.7068,241.5396c-3.7061,0-7.4113-1.411-10.2333-4.2401c-5.6581-5.6584-5.6581-14.8228,0-20.4814 l93.127-93.1266c5.6581-5.6585,14.8224-5.6585,20.4805,0c5.6589,5.6581,5.6589,14.8228,0,20.4809l-93.127,93.127 C774.119,240.1285,770.4129,241.5396,766.7068,241.5396L766.7068,241.5396z"
  })), /*#__PURE__*/React.createElement("line", {
    fill: "#FFCA72",
    x1: 504.9998,
    y1: 14.4803,
    x2: 504.9998,
    y2: 128.9293
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#37474F",
    d: "M504.9998,143.4101c-7.9956,0-14.4807-6.4778-14.4807-14.4808V14.4803 C490.5191,6.4847,497.0042,0,504.9998,0c7.9964,0,14.4803,6.4847,14.4803,14.4803v114.449 C519.4801,136.9323,512.9962,143.4101,504.9998,143.4101L504.9998,143.4101z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.9dd2ded16231ed3b5f224533925a2816.svg";
export { ForwardRef as ReactComponent };